module.exports = __webpack_public_path__ + "static/media/U1-T2-3-1d.ebf80e04.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/U1-T2-3-1d.mp3
// module id = 576
// module chunks = 0